import { CHAIN_IDS, ChainLayer } from '@cronos-app/sdk';
import { getLayerOfChain } from '@cronos-app/sdk/dist/esm/utils';
import { currentWallet } from '@cronos-app/wallet';
import { USER_LAYER_TO_INTERNAL } from '@ui/config/layer';
import { useRouter } from 'next/router';

export const useGlobalChainLayer = () => {
  const walletChainId = currentWallet.useChainId();
  const layerFromQueryParam = useChainLayerFromQuery();
  if (layerFromQueryParam) return layerFromQueryParam;
  const walletChainIsSupported =
    !!walletChainId && CHAIN_IDS.includes(walletChainId);
  if (walletChainIsSupported) {
    return getLayerOfChain(walletChainId);
  }
  return ChainLayer.L2;
};

export const useIsUsingChainLayerFromQuery = () => {
  const chainLayerFromQuery = useChainLayerFromQuery();
  return !!chainLayerFromQuery;
};

const useChainLayerFromQuery = () => {
  const { query } = useRouter();
  const layerFromQueryParam =
    query.chain && typeof query.chain === 'string'
      ? USER_LAYER_TO_INTERNAL[query.chain]
      : undefined;
  return layerFromQueryParam;
};
